/*
 * @Author: pengyong
 * @Date: 2020-11-15 16:58:16
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-17 23:07:02
 * @Description: 通用接口
 * @FilePath: /exhibit/src/api/common.js
 */
import axios from "@/utils/axios.js";
import { BASE_URL, LOGIN_URL, TONGJI_URL } from "./config";

// 获得国家、地区列表
export function getCountry() {
    return axios.$get(`${BASE_URL}/visitor/api/v1/country`);
}
// 发送手机号验证码
export function sendSmsCode(params) {
    return axios.$post(`${LOGIN_URL}/v1/sms/verify-code`, params);
}
// 发送邮箱验证码
export function sendEmailCode(params) {
    return axios.$post(`${LOGIN_URL}/v1/mail/verify-code`, params);
}
// 上传附件
export function uploadFile(params) {
    return axios.$post(`${BASE_URL}/storage/api/v1/attachment`, params);
}
// 展厅日志
export function sendVhallview(params) {
    return axios.$post(`${TONGJI_URL}v1/vhallview`, params);
}
// export function sendVhallview(params){
//     return axios.$post(`${TONGJI_URL}v1/vhallview`, params);
// }


// WEBPACK FOOTER //
// ./src/api/common.js